import type { MRT_ColumnDef } from "mantine-react-table-open";
import { sortBackendDates } from "../../../../../utils/dates/sortBackendDates";
import type { MeterConfigurationData } from "../../../ThirdPartySystems.types";

function getByteMeeColumns(): Array<MRT_ColumnDef<MeterConfigurationData>> {
  return [
    { header: "Windpark ID", accessorKey: "parameters.windparkId" },
    { header: "Anlagenname", accessorKey: "parameters.windparkName" },
    { header: "Seriennummer", accessorKey: "parameters.serialNumber" },
    {
      header: "Inbetriebnahme",
      accessorKey: "parameters.installationDate",
      size: 160,
      sortingFn: (rowA, rowB) =>
        "installationDate" in rowA.original.parameters &&
        "installationDate" in rowB.original.parameters
          ? sortBackendDates(
              rowA.original.parameters.installationDate,
              rowB.original.parameters.installationDate
            )
          : 0,
      filterFn: "includesString",
      Cell: ({ renderedCellValue }) => renderedCellValue ?? "Unbekannt"
    }
  ];
}

export { getByteMeeColumns };
